module.exports = __webpack_public_path__ + "static/media/vip-benefits-sprite.63f8029a.svg";